import { useContext } from 'react';
import { OrderInfoContext } from '../../helpers/provider/context';

export const useOrderInfo = () => {
	const context = useContext(OrderInfoContext);
	if (!context) {
		throw new Error(
			'useOrderInfo must be used within an OrderInfoProvider',
		);
	}
	return context;
};

export const useOrderInfoWithoutError = () => {
	const context = useContext(OrderInfoContext);
	return context;
};
